import { useState } from "react";

const LINKS = {
  栏目: ["本期观察", "候选人榜单", "提名盘点", "争夺动态", "焦点封面"],
  阅读: ["周刊旧刊", "提名线索征集", "读者来稿", "编辑手记"],
  关于: ["关于黑料王", "栏目宗旨", "转载规范", "联系方式"],
};

export default function Footer() {
  const [status, setStatus] = useState<"idle" | "ok" | "err">("idle");
  const [msg, setMsg] = useState("");

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // honeypot check
    const honeypot = String(fd.get("contact_alt") || "").trim();
    if (honeypot) {
      setStatus("ok");
      setMsg("感谢订阅，最新一期将第一时间送达你的邮箱。");
      form.reset();
      return;
    }
    fd.delete("contact_alt");

    try {
      const res = await fetch(
        "https://readdy.ai/api/form/dae2oo9tto0ceqqngoh0",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
        }
      );
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const isSpam = /spam|form data is spam/i.test(text);
      if (res.ok && code === "OK" && !isSpam) {
        setStatus("ok");
        setMsg("感谢订阅，最新一期将第一时间送达你的邮箱。");
        form.reset();
      } else {
        setStatus("err");
        setMsg(serverMsg && !isSpam ? serverMsg : "提交未成功，请稍后再试或检查邮箱格式。");
      }
    } catch {
      setStatus("err");
      setMsg("网络似乎开小差了，请稍后再试。");
    }
  }

  return (
    <footer className="bg-[#6f4a2c] text-[#f7ecd9]">
      {/* subscribe band */}
      <div className="border-b border-[#8a6845]">
        <div className="mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-6 px-4 py-12 md:px-6 lg:grid-cols-2">
          <div>
            <p className="text-xs font-semibold tracking-[0.25em] text-[#f0c8a6] uppercase">
              The Dispatch
            </p>
            <h3 className="font-display mt-2 text-2xl font-black text-[#fff6ea] md:text-3xl">
              每周一封，锁定王位人选
            </h3>
            <p className="mt-2 max-w-md text-sm leading-relaxed text-[#ecd9c2]">
              订阅《黑料王周刊》，每周给你推送一份候选人热度榜与提名线索速览，不错过任何下一位人选的风向变化。
            </p>
          </div>

          <form onSubmit={onSubmit} data-readdy-form className="w-full lg:pl-6">
            <div className="flex flex-col gap-3 sm:flex-row">
              <label htmlFor="sub-email" className="sr-only">
                邮箱地址
              </label>
              <input
                id="sub-email"
                type="email"
                name="email"
                required
                placeholder="输入你的邮箱地址"
                className="w-full rounded-md border border-[#a8875f] bg-[#fbf7ef] px-4 py-3 text-sm text-[#18130e] placeholder-[#a18a6b] focus:border-[#fff6ea] focus:outline-none"
              />
              <button
                type="submit"
                className="whitespace-nowrap rounded-md bg-[#e0b184] px-6 py-3 text-sm font-bold text-[#4a2f18] transition-colors hover:bg-[#f0cba6]"
              >
                立即订阅
              </button>
            </div>

            <input
              type="text"
              name="contact_alt"
              className="hp-field"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />

            {status === "ok" && (
              <p className="mt-3 flex items-center gap-1.5 text-sm text-[#b7e0c0]">
                <i className="ri-checkbox-circle-fill"></i> {msg}
              </p>
            )}
            {status === "err" && (
              <p className="mt-3 flex items-center gap-1.5 text-sm text-[#ffd5c4]">
                <i className="ri-error-warning-fill"></i> {msg}
              </p>
            )}
            <p className="mt-2 text-xs text-[#cbb491]">
              订阅即表示同意接收本刊推送，可随时退订。仅用于内容投递，绝不外泄。
            </p>
          </form>
        </div>
      </div>

      {/* link grid */}
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2">
            <p className="font-display text-2xl font-black text-[#fff6ea]">黑料王</p>
            <p className="mt-2 max-w-xs text-sm leading-relaxed text-[#ecd9c2]">
              一本追踪王位人选更替的独立观察周刊。聚焦候选人提名、热度与争夺进展，替你锁定下一位黑料王人选。
            </p>
          </div>
          {Object.entries(LINKS).map(([group, items]) => (
            <div key={group}>
              <h4 className="text-sm font-bold text-[#f0c8a6]">{group}</h4>
              <ul className="mt-3 space-y-2">
                {items.map((it) => (
                  <li key={it}>
                    <a
                      href="#top"
                      className="whitespace-nowrap text-sm text-[#e2cfb4] transition-colors hover:text-[#fff6ea]"
                    >
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-[#8a6845]">
        <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-[#cbb491] sm:flex-row md:px-6">
          <p>© 2026 黑料王周刊 · 本刊内容仅供娱乐与话题观察参考</p>
          <div className="flex items-center gap-4">
            <a href="#top" className="flex items-center gap-1 hover:text-[#fff6ea]">
              <i className="ri-arrow-up-line"></i> 回到顶部
            </a>
            <a href="#feed" className="hover:text-[#fff6ea]">
              今日动态
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}